import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { SlideInComponent } from '../slide-in/slide-in.component';
import { ButtonComponent } from '../button/button.component';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslocoDirective, TranslocoModule } from '@jsverse/transloco';
import { PriceComponent } from '../price/price.component';
import { CartService } from '../../pages/cart-page/cart.service';
import { NavigationStart, Router, RouterLink } from '@angular/router';
import { TranslateRoutePipe } from '../../pipes/translate-route.pipe';
import { AddLocalePipe } from '../../pipes/url-locale.pipe';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Cart, LineItem } from '../../pages/cart-page/cart.types';

@Component({
  selector: 'app-mini-cart',
  imports: [
    CommonModule,
    SlideInComponent,
    ButtonComponent,
    SvgIconComponent,
    NgOptimizedImage,
    TranslocoDirective,
    PriceComponent,
    TranslocoModule,
    RouterLink,
    TranslateRoutePipe,
    AddLocalePipe,
  ],
  templateUrl: './mini-cart.component.html',
  styleUrls: ['./mini-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MiniCartComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);
  readonly cart = inject(CartService);
  cartData!: Cart;

  ngOnInit() {
    this.cart.cart$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((cart) => {
      this.cartData = cart;
      this.cdr.markForCheck();
    });

    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.cart.closeMiniCart();
      });
  }

  onClose(): void {
    this.cart.closeMiniCart();
  }

  removeItem(item: LineItem): void {
    this.cart.removeItem(item);
  }
}
